import React, { useEffect, useMemo, useState } from "react";
import "./OpenHomePosts.scss";
import DownArrowIcon from "../../../../components/icons/DownArrowIcon";
import { FontApi } from "../../../../utils/api/Font";
import BottomSaveButton from "../../buttons/BottomSaveButton";
import toast from "react-hot-toast";
import { LocalStorageHelpers } from "../../../../utils/helpers/localstorage.helpers";

const OpenHomePosts = () => {
  const user = LocalStorageHelpers.getUserData();

  const isAgent = !!(user && "role" in user && user.role === "agent");
  const agencyId = (() => {
    if (!user) return "";

    if (isAgent) {
      const ref = user.agency_ref as any;

      if (typeof ref === "object") {
        return ref?._id || ref?.$oid || "";
      }

      return ref || "";
    }

    const id = user._id as any;

    if (typeof id === "object") {
      return id?._id || id?.$oid || "";
    }

    return id || "";
  })();
  // const dayOptions = useMemo(() => Array.from({ length: 31 }, (_, i) => i), []);
  const dayOptions = useMemo(() => Array.from({ length: 6 }, (_, i) => i + 1), []);

  const [days, setDays] = useState<number | "">("");
  const [initialDays, setInitialDays] = useState<number | "">("");

  const [state, setState] = useState({
    isLoading: false,
    saveIsLoading: false,
    showSaveButton: false,
  });

  const onSubmitHandler = async () => {
    if (days === "") {
      toast.error("Please select days");
      return;
    }

    const payload = {
      open_home_posts: {
        posting_window_days: days,
      },
    };

    setState((prev) => ({ ...prev, saveIsLoading: true }));

    const res = await FontApi.UpdateAgencySettings(payload);

    if (res.success) {
      toast.success("Open home settings updated");
      setInitialDays(days);
      setState((prev) => ({
        ...prev,
        saveIsLoading: false,
        saveBtn: false,
      }));
    } else {
      toast.error(res.error);
      setState((prev) => ({ ...prev, saveIsLoading: false }));
    }
  };

  const fetchData = async () => {
    setState((prev) => ({ ...prev, isLoading: true }));

    const res = await FontApi.GetAgencySettings({
      agency_id: agencyId,
    });

    if (res.success) {
      const value = res.data?.open_home_posts?.posting_window_days;

      if (value !== undefined && value !== null) {
        setDays(value);
        setInitialDays(value);
      } else {
        setDays("");
        setInitialDays("");
      }
    }

    setState((prev) => ({ ...prev, isLoading: false }));
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (isAgent) {
      setState((prev) => ({ ...prev, showSaveButton: false }));
      return;
    }

    if (days === "" && initialDays === "") {
      setState((prev) => ({ ...prev, showSaveButton: false }));
      return;
    }

    if (days !== initialDays) {
      setState((prev) => ({ ...prev, showSaveButton: true }));
    } else {
      setState((prev) => ({ ...prev, showSaveButton: false }));
    }
  }, [days, initialDays, isAgent]);

  const onClickDecline = () => {
    setDays(initialDays);
  };

  console.log("days:", days, "initialDays:", initialDays);
  console.log("agencyId:", agencyId);

  return (
    <div className="open-home-post-settings">
      <h1 className="page-title">Open home post settings</h1>

      <div className="settings-section">
        <h2 className="section-title">Posting window</h2>
        <p className="section-description">
          Set how many days prior to the inspection the social media post should
          be published.
        </p>

        <label className="field-label">Days</label>

        <div className="select-wrap">
          <select
            className="days-select"
            value={days}
            disabled={isAgent}
            onChange={(e) =>
              setDays(e.target.value === "" ? "" : Number(e.target.value))
            }
          >
            <option value="">Select days</option>

            {dayOptions.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>

          <span className="chevron">
            <DownArrowIcon />
          </span>
        </div>
      </div>

      {!isAgent && (
        <BottomSaveButton
          is_loading={state.saveIsLoading}
          cancle_button_name="Decline"
          save_button_name="Save Changes"
          button_hide={state.showSaveButton}
          onCancel={onClickDecline}
          submitButtonType={"button"}
          onSubmitClick={onSubmitHandler}
        />
      )}
    </div>
  );
};

export default OpenHomePosts;
